import { render } from "./NotFoundView.vue?vue&type=template&id=aa014a98&scoped=true"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=aa014a98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa014a98"]])

export default __exports__